import React, { useState } from 'react';
import Theme from 'Theme';
import { ThemeProvider } from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { ExpandIcon } from 'common/components/icons';
import { Accordion, Grid,Typography, AccordionSummary, AccordionDetails, TableBody, Table, TableRow, TableCell } from '@material-ui/core';


const styles = {
    root: {
        width: '100%',
    },
    typography: {
        display: "inline-block",
    },
    nameTypography: {
        extend: 'typography',
        fontSize: "16px",
    },
    infoLabel: {
        extend: 'typography',
        paddingTop: '1.5px'
    },
    idLabel: {
        extend: 'typography',
        paddingTop: '1.5px',
        paddingLeft: '5px',
    },
    accordionDetail: {
        marginTop: '-10px',
        paddingTop: '0px',
    },
    tableCell: {
        maxWidth: '15vw',
        textWrap: 'break-word',
    }
};

const ClusterPanel = ({ classes, appId, data}) => {
    const [expanded, setExpanded] = useState(false)

    const countProblematicRLCs = (RLCs) => Object.keys(RLCs).filter((r) => RLCs[r]['is_problematic']).length;

    return <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary
            expandIcon={<ExpandIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
        >
            <Grid container>
                <Grid item xs>
                    <ThemeProvider theme={Theme}>
                        <Typography className={classes.nameTypography} variant='subtitle2'>{data['ms_name']}</Typography>
                    </ThemeProvider>
                    <Typography className={classes.idLabel} variant='caption' color="textSecondary">(id: {appId})</Typography>
                </Grid> 
                <Grid container item xs spacing={1} justify="flex-end" alignItems="flex-end">
                    <Grid item>
                        <Typography className={classes.infoLabel} variant='caption' color="textSecondary">Deployments (problematic/total): {countProblematicRLCs(data['RLCs'])}/{Object.keys(data['RLCs']).length}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetail}>
            <Grid container direction="column">
                {Object.keys(data['RLCs']).map((r, rIndex) =>
                <Grid container item className={classes.container} key={`rp#${rIndex}`}>
                    <Grid item xs>
                        <Typography className={classes.typography} variant='subtitle2'>{r}</Typography>
                    </Grid> 
                    <Grid container item xs spacing={1} justify="flex-end" alignItems="flex-end">
                        <Grid item>
                            <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{data['RLCs'][r]['cluster_id']} ,</Typography>
                        </Grid>
                        <Grid item>
                            <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">LB {data['RLCs'][r]['lb_id']} ,</Typography>
                        </Grid>               
                        <Grid item>
                            <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">Container {data['RLCs'][r]['container_id']}</Typography>
                        </Grid>         
                    </Grid>
                </Grid>
                )}
                <Grid item>
                    {data['last_changes'].length === 0 ? 
                    <Grid container justify="center">
                        <Grid item >
                            No changes made yet
                        </Grid> 
                    </Grid> 
                    : 
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <Typography variant="subtitle2">Setting</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle2">Old Value</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle2">New Value</Typography>
                                </TableCell>
                            </TableRow>
                            {data['last_changes'].map((array) => 
                                array.map((c, cIndex) =>
                                <TableRow key={`rp#${cIndex}`}>
                                    <TableCell className={classes.tableCell}>
                                        {c['setting']}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {c['old_val'] && c['old_val'].toString()}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        {c['new_val'] && c['new_val'].toString()}
                                    </TableCell>
                                </TableRow>)
                            )} 
                        </TableBody>
                    </Table>}
                </Grid>
            </Grid>
        </AccordionDetails>
    </Accordion>
};

export default withStyles(styles)(ClusterPanel);